/**
 * Formats a weight value (stored as kg) for display,
 * converting to lbs when isMetric is false.
 */
export function formatWeight(kg: number | null, isMetric: boolean): string {
  if (kg === null) return '--';
  return isMetric
    ? `${kg.toFixed(1)} kg`
    : `${(kg * 2.20462).toFixed(1)} lbs`;
}
